import { clientApi } from '../api';

interface CreateNetworkRegisterContact {
  email: string;
  name: string;
  phone: string;
  city: string;
  comment: string;
}

export const createNetworkRegisterContact = async (
  params: CreateNetworkRegisterContact,
) => {
  const response = await clientApi.post<{ success: boolean }>(
    '/contact',
    params,
  );

  return response.data;
};
